import styled from 'styled-components';
import { DataGrid } from '@mui/x-data-grid';

import colors from '../../../styles/colors';

const TableClasses = {
  HIGHLIGHTED_ROW: 'highlighted-row',
};

const StyledDataGrid = styled(DataGrid)`
  background-color: ${colors.base.alpha};
  min-height: 350px;
  
  .MuiDataGrid-columnHeaderTitle {
    font-weight: 500;
    color: ${colors.shades.gamma10};
    text-transform: uppercase;
    font-size: 12px;
  }
  .${TableClasses.HIGHLIGHTED_ROW} {
    background-color: ${colors.base.primary};
    &:hover {
      background-color: ${colors.base.primary};
    }
  }
`;

export {
  StyledDataGrid,
  TableClasses,
};
